import styled from 'styled-components'
import Typography from '../../../global/typography'

export const NavDropdownItem = styled.div`
  margin: 0 12px;
  padding: 24px 0;
  position: relative;
  ${p => p.theme.breakpoints.down('md')} {
    padding: 16px 0 14px 0;
    margin: 0 8px;
  }
  ${p => p.theme.breakpoints.down('sm')} {
    padding: 0;
    margin: 0;
  }

  &.BlogNav__Dropdown {
    cursor: pointer;
    ${p => p.theme.breakpoints.down('sm')} {
      width: 100%;
    }
  }
  .BlogNavDropdown__Arrow-Title {
    ${p => p.theme.breakpoints.down('sm')} {
      margin-bottom: 8px;
      padding: 10px 0;
      &:hover {
        .BlogNav__Mobile-Menu-Arrow {
          path {
            fill: ${p => p.theme.webMktPalette.icon.blueDark};
          }
        }
      }
    }
  }
  .BlogNavDropdown__Title {
    color: rgba(255, 255, 255, 0.301961);
    transition: 0.1s color cubic-bezier(0.4, 0, 0.2, 1);
    ${p => p.theme.breakpoints.down('sm')} {
      color: rgb(255, 255, 255);
    }
  }

  .BlogNav__Mobile-Menu-Arrow {
    display: none;
    ${p => p.theme.breakpoints.down('sm')} {
      display: block;
      width: 15px;
      height: auto;
      position: absolute;
      top: 16px;
      right: 0;
      transition: 0.1s all cubic-bezier(0.4, 0, 0.2, 1);
    }
    ${(p: any) => (p.$secondaryDrawerOpen ? `transform: rotate(180deg);` : `transform: rotate(0);`)}
  }

  .BlogNavDropdown__Arrow {
    width: 24px;
    height: 24px;
    right: -24px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    path {
      transition: 0.1s all cubic-bezier(0.4, 0, 0.2, 1);
      fill: rgba(255, 255, 255, 0.301961);
    }
    ${p => p.theme.breakpoints.down('sm')} {
      display: none;
    }
  }

  &:after {
    content: '';
    width: calc(100% + 24px);
    height: 2px;
    background: #1e1e1e;
    position: absolute;
    bottom: 0px;
    transition: 0.1s color cubic-bezier(0.4, 0, 0.2, 1);
  }

  &:hover {
    ${p => p.theme.breakpoints.up('md')} {
      &:after {
        background: #38c6f4;
      }

      .BlogNavDropdown__Links {
        display: flex;
        flex-direction: column;
        box-shadow: 0px 16px 16px -8px rgba(0, 0, 0, 0.2);
      }
      .BlogNavDropdown__Title {
        color: #38c6f4;
      }
      .BlogNavDropdown__Arrow {
        path {
          fill: ${p => p.theme.webMktPalette.icon.blueDark};
        }
      }
    }
  }
`

export const BlogNavLinkTitle = styled(Typography)`
  ${({ theme }) => {
    return `
    position: relative;
    margin: 0 12px;
    &.BlogNav__CTA--Active {
      .NavDropdownItem__Link {
        color: ${theme.webMktPalette.text.actionDark};
      }
      &:after {
        background: ${theme.webMktPalette.text.actionDark};
      }
    }
    &.BlogNav__CTA--Inactive {
      .NavDropdownItem__Link {
        color: ${theme.webMktPalette.text.primaryWhite};
      }
      &:after {
        background: #1e1e1e;
      }
    }
    .NavDropdownItem__Link {
      transition: 0.1s color cubic-bezier(0.4, 0, 0.2, 1);
      padding: 12px 0;
      display: block;
      &:hover {
        color: #38c6f4;
      }
    }
    &:after {
      content: '';
      width: calc(100% + 16px);
      height: 2px;
      position: absolute;
      bottom: -12px;
      left: -8px;
      transition: 0.1s color cubic-bezier(0.4, 0, 0.2, 1);
      ${theme.breakpoints.down('md')} {
        bottom: -3px;
      }
      ${theme.breakpoints.down('sm')} {
        display: none;
      }
    }
    ${theme.breakpoints.down('md')} {
      margin: 0 8px;
      font-size: 14px;
      line-height: 24px;
    }
  `
  }}

  ${NavDropdownItem} {
    margin: 0;
  }
`

export const BlogNavContainer = styled.div`
  position: relative;
  z-index: 10;
  ${({ theme, mobileDrawerOpen }: any) => {
    const mobileDrawerStyles = mobileDrawerOpen ? `display: flex;` : `display: none;`

    return `
    background: #1e1e1e;
    .BlogNav__Inner {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      justify-content: space-between;
      height: 72px;
      ${theme.breakpoints.down('sm')} {
        ${mobileDrawerStyles}
        flex-direction: column;
        align-items: flex-start;
        height: auto;
      }
      .BlogNav__Inner-Links {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin: 0 -12px;
        ${theme.breakpoints.down('md')} {
          margin: 0 -8px;
        }
        ${theme.breakpoints.down('sm')} {
          flex-direction: column;
          align-items: flex-start;
          width: 100%;
        }
      }
    }
  `
  }}

  .BlogNav__Subscribe {
    color: ${p => p.theme.webMktPalette.text.actionOrange};
    ${p => p.theme.breakpoints.down('sm')} {
      padding: 10px 40px 10px 0;
      margin-bottom: 8px;
    }
    &:hover {
      color: ${p => p.theme.webMktPalette.text.primaryWhite};
      .CTA__Arrow-Container {
        svg {
          #ArrowPath {
            fill: #ffffff;
          }
        }
      }
    }
    &:focus,
    :active {
      background: none;
      color: ${p => p.theme.webMktPalette.text.secondary};
      outline: none;
      .CTA__Arrow-Container {
        svg {
          #ArrowPath {
            fill: #595a5c;
          }
        }
      }
    }
    .CTA__Arrow-Container {
      svg {
        #ArrowPath {
          fill: #fa4616;
        }
      }
    }
  }
  .BlogNav__Global-Container {
    ${p => p.theme.breakpoints.down('md')} {
      max-width: 100%;
      padding: 0 30px;
    }
    ${p => p.theme.breakpoints.down('sm')} {
      padding: 0 16px;
    }
  }
  .BlogNav__Mobile-Menu-Switcher {
    display: none;
    padding: 16px 0;
    cursor: pointer;
    &:hover {
      .BlogNav__Mobile-Menu-Arrow {
        path {
          fill: ${p => p.theme.webMktPalette.icon.blueDark};
        }
      }
    }

    ${p => p.theme.breakpoints.down('sm')} {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .BlogNav__Mobile-Menu-Title {
      color: ${p => (p.mobileDrawerOpen ? 'rgba(255, 255, 255, 0.301961)' : '#ffffff')};
      margin-left: 8px;
    }
    .BlogNav__Mobile-Menu-Arrow {
      width: 16px;
      height: 16px;
      transition: 0.1s color cubic-bezier(0.4, 0, 0.2, 1);
    }
  }
`
export const InnerDrawer = styled.div`
  ${({ theme, $secondaryDrawerOpen }: any) => {
    const mobileDrawerStyles = $secondaryDrawerOpen ? `display: flex;` : `display: none;`

    return `
    background: #ffffff;
    padding: 8px 0;
    display: none;
    position: absolute;
    z-index: 4;
    top: 72px;
    left: -24px;
    ${theme.breakpoints.down('md')} {
      top: 54px;
    }
    ${theme.breakpoints.down('sm')} {
      padding: 4px 0;
    }

    ${theme.breakpoints.down('sm')} {
      ${mobileDrawerStyles}
      position: relative;
      z-index: unset;
      top: unset;
      left: unset;
      flex-direction: column;
      background: #111212;
      margin: 0 -24px 0-12px;
    }

    .BlogNavDropdown__Inner-Item {
      background-color: #ffffff;
      padding: 8px 24px;
      width: 240px;
      transition: all 0.033s ease;
      position: relative;
      box-sizing: border-box;
      ${theme.breakpoints.down('sm')} {
        background: #111212;
        padding: 8px 24px 8px 40px;
        margin: 4px 0;
        width: 100%;
      }
      .BlogNavDropdown__Inner-Item-Title {
        transition: 0.1s color cubic-bezier(0.4, 0, 0.2, 1);
        ${theme.breakpoints.down('sm')} {
          color: #ffffff;
        }
        &:hover {
          ${theme.breakpoints.down('sm')} {
            color: #38c6f4;
          }
        }
      }

      &:after {
        content: '\\2192';
        width: 16px;
        height: 16px;
        line-height: 16px;
        position: absolute;
        opacity: 0;
        top: 50%;
        transform: translateY(-50%);
        right: 24px;
        transition: 0.033s;
      }
      &:hover {
        ${theme.breakpoints.up('md')} {
          background-color: ${theme.webMktPalette.icon.blueLight};
          color: #fff;
          p {
            color: #fff;
          }
          .BlogNavDropdown__Links {
            display: flex;
            flex-direction: column;
          }
          &:after {
            opacity: 1;
          }
        }
      }
    }
  `
  }}
`
